import { createFileRoute } from '@tanstack/react-router';
import { ClientOnboardingWizard, type NewClientSearch } from '@/components/ClientOnboardingWizard';

export const Route = createFileRoute('/_authenticated/clients/new')({
  validateSearch: (search: Record<string, unknown>): NewClientSearch => ({
    clientId: typeof search.clientId === 'string' ? search.clientId : undefined,
  }),
  component: ClientOnboardingWizardRoute,
});

function ClientOnboardingWizardRoute(): JSX.Element {
  const { clientId } = Route.useSearch();
  return <ClientOnboardingWizard initialClientId={clientId ?? null} />;
}
